import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "src/shared/api/base-query";
import { pagedQueryFn } from "src/shared/api/paged-query-fn";
import type { QuerySubscriptionOptions } from "src/shared/api/query-subscription-options";

import { ITechOperationMeasuresSet } from "../shared/interfaces/tech-operation-measures-set";

export const techOperationMeasuresSetsApi = createApi({
  reducerPath: "techOperationMeasuresSetsApi",
  baseQuery,
  endpoints: (builder) => ({
    fetchTechOperationMeasuresSetsWithDeleted: builder.query<
      ITechOperationMeasuresSet[],
      void
    >({
      queryFn: pagedQueryFn<ITechOperationMeasuresSet, ITechOperationMeasuresSet[]>(
        { url: "TechOperationMeasuresSetsV2", params: { includeDeleted: true } },
        (dtos) => dtos
      ),
    }),
  }),
});

const useTechOperationMeasuresSetsEndpoint =
  techOperationMeasuresSetsApi.endpoints.fetchTechOperationMeasuresSetsWithDeleted
    .useQuery;

export function useFetchTechOperationMeasuresSetsWithDeleted(
  options?: QuerySubscriptionOptions<typeof useTechOperationMeasuresSetsEndpoint>
) {
  return useTechOperationMeasuresSetsEndpoint(undefined, options);
}
